import React from 'react';

export const ServerUrlContext = React.createContext('');
